/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderViewedType {
    VIEW_MAIL_PRICE = 'view_mail_price',
    VIEW_SITE_PRICE = 'view_site_price',
    VIEW_MAIL_PAY = 'view_mail_pay',
    VIEW_SITE_PAY = 'view_site_pay',
}